import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

const TITLES = {
  "/": "Home",
  "/shop": "Shop",
  "/categories": "Categories",
  "/cart": "Cart",
  "/quote": "Request a Quote",
  "/quote/status": "Quote Status",
  "/login": "Login",
  "/register": "Create Account",
  "/forgot-password": "Forgot Password",
  "/reset-password": "Reset Password",
  "/account": "Account",
  "/orders": "Order History",
};

export default function UserLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = TITLES[pathname] || (pathname.startsWith("/product/") ? "Product" : pathname.startsWith("/orders/") ? "Order" : null);
    document.title = page ? `${page} | Shop` : "Shop";
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
